import DefinitionTypes from './definition.types'

const INITIAL_STATE = {
	// [language]: null // eg: vi: null, en: null
	term: '',
	dictWord: {},
	wordtype: {},
	spelling: '',
	isLoading: false,
}

const DefinitionReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case DefinitionTypes.SET_TERM:
			return { ...state, term: payload }
		case DefinitionTypes.SET_DEFINITION:
			return { ...state, ...payload, isLoading: false }
		case DefinitionTypes.SET_WORD_TYPE:
			return { ...state, ...payload, isLoading: false }
		case DefinitionTypes.SET_DEFINITION_LOADING:
			return { ...state, isLoading: true }
		case DefinitionTypes.RESET_DEFINITION:
			return { ...INITIAL_STATE, term: payload || '' }
		case DefinitionTypes.SET_DEFINITION_VN:
			// Note workaround: Get spelling and definition En at the same time
			return {
				...state,
				definitionVN: payload.definitionVN,
				spelling: payload.spelling,
				isLoading: false,
			}
		case DefinitionTypes.SET_DEFINITION_EN:
			return { ...state, definitionEN: payload, isLoading: false }

		// dict word
		case DefinitionTypes.UPDATE_DICT_WORD_IN_DETAIL: {
			return {
				...state,
				dictWord: {
					...state.dictWord,
					...payload,
				},
			}
		}

		default:
			return state
	}
}

export default DefinitionReducer
